<template>
  <div>
    <b-overlay>

      <b-modal id="bv-modal-manual-shift-assignment" hide-footer>
        <template #modal-title>
          Create Direct Assignment <b-icon icon="info-circle" v-b-tooltip.hover.top="'Assign the employee to a temporary shift for a selected date range. After the end date, the system will automatically return the employee to their original shift.'"></b-icon>
        </template>
        <roster-manual-shift-assignment @closeModal="closeModal"></roster-manual-shift-assignment>
      </b-modal>

      <b-overlay :show="loading">
        <div class="ibox px-3 py-4">
          <b-alert show v-for="(error, index) in errors" :key="index" class="mb-2" variant="warning">{{error}}</b-alert>

          <div class="row">
            <div class="col-9">
              <div class="border-0 no-shadow">
                <div class="mb-4">
                  <h5 class="mb-3 pb-3">Attendance Log</h5>
                  <b-input-group class="date-range-picker d-flex flex-row justify-content-start align-items-end">
                    <b-form-group id="effective_start_date-group" label="Start Date" label-for="effective_start_date" class="required-field mb-0 mr-2">
                      <b-input-group class="mb-0">
                        <b-form-input id="effective_start_date" name="effective_start_date" v-model="start" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                      autocomplete="off" :state="validateState('effective_start_date')" aria-describedby="effective_start_date-feedback" data-vv-as="Start Date"/>
                        <b-input-group-append class="mb-0">
                          <b-form-datepicker class="mb-0" id="day_one" button-only right locale="en-US" v-model="start" />
                        </b-input-group-append>
                        <b-form-invalid-feedback id="effective_start_date-feedback">
                          {{ veeErrors.first('effective_start_date') }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group id="effective_end_date-group" label="End Date" label-for="effective_end_date" class="required-field mb-0">
                      <b-input-group class="mb-0">
                        <b-form-input id="effective_end_date" name="effective_end_date" v-model="end" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                      autocomplete="off" :state="validateState('effective_end_date')" aria-describedby="effective_end_date-feedback" data-vv-as="End Date"/>
                        <b-input-group-append class="mb-0">
                          <b-form-datepicker :min="start" class="mb-0" id="day_two" button-only right locale="en-US" v-model="end" />
                        </b-input-group-append>
                        <b-form-invalid-feedback id="effective_end_date-feedback">
                          {{ veeErrors.first('effective_end_date') }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                    <b-button class="ml-2" @click="loadData">
                      Preview Report
                    </b-button>
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="col-3 d-flex justify-content-end align-items-end pb-4">
              <b-button @click="showModal">Manual Assignment</b-button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col" v-for="stat in summaryStats" :key="stat.label">
              <div class="stat-box bg-wash px-3 py-4">
                <h2 class="value">{{ stat.value }}</h2>
                <p class="label my-0">{{ stat.label }}</p>
              </div>
            </div>
          </div>


          <div class="section-card mb-4 bg-wash px-3 py-4" v-if="shift_distribution.length > 0 && roster == 1">
            <h5 class="mb-3">Shift Distribution</h5>
            <div class="d-flex flex-wrap">
              <span v-for="d in shift_distribution" :key="d.name" class="shift-tag px-3 py-1 rounded mr-2" :style="{ background: d.color + '22', color: d.color }">{{ d.name }} ({{ d.count }} days)</span>
            </div>
          </div>

          <h5 class="mb-3">Schedule Details</h5>

            <div class="table-responsive employee-table-wrapper">
              <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
                <thead class="table-head">
                <tr>
                  <th>Date</th>
                  <th>Day</th>
                  <th v-if="roster == 1">Shift Name</th>
                  <th v-if="roster == 1">Shift Time</th>
                  <th v-else>Office Time</th>
                  <th>Clock In</th>
                  <th>Clock Out</th>
                  <th>Work Time</th>
                  <th>Status</th>
                </tr>
                </thead>

                <tbody>
                <tr v-b-tooltip.hover="row.data_source" v-for="row in paginatedData" :key="row.id || (row.day + '-' + row.shift_id)"  class="hover-bg table-row border-bottom mx-2">
                  <td>{{ moment(row.day).format('D MMM, YYYY') }}</td>
                  <td>{{ moment(row.day).format('dddd') }}</td>
                  <td v-if="roster == 1">
                    <span class="shift-tag small px-3 py-1 rounded d-block text-center" :style="{ background: row.shift.color + '22', color: row.shift.color }">{{ row.shift.name }}</span>
                  </td>
                  <td>{{ row.shift.shift_time }}</td>
                  <td>{{ row.check_in }}</td>
                  <td>{{ row.check_out }}</td>
                  <td>{{ row.work_time }}</td>
                  <td>
                    <span class="shift-tag small px-3 py-1 rounded d-block text-center" :style="{ background: row.label_color + '22', color: row.label_color }">{{ row.label }}</span>
                  </td>
                </tr>

                <tr v-if="!rows.length"  class="hover-bg table-row border-bottom mx-2">
                  <td colspan="8" class="text-muted text-center py-3">No schedule found for the selected date range.</td>
                </tr>
                </tbody>
              </table>

                <div>
                    <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled">
                                    <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
                                </li>
                                <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                                prev-text="Previous" next-text="Next" base-url="#" first-number last-number>
                            </b-pagination-nav>
                        </div>

                    </div>
                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                        <span class="d-block text-center">{{ blankmsg }}</span>
                        <img v-if="showoverlay" v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" />
                    </div>
                </div>
            </div>
        </div>
      </b-overlay>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data(){
    const today = new Date();
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    const last  = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    let sortOrders = {};
    let columns = [
                    {label: 'Name', name: 'name' },
                    {label: 'Email', name: 'email'},
                    {label: 'Phone', name: 'phone'},
                    {label: 'Role', name: 'role_id'},
                    {label: 'Status', name: 'Status'},
                ];
    columns.forEach((column) => {sortOrders[column.name] = -1;});
    return {
      roster: 1,
      componentKey:0,
      employee_id: 0,
      selectedEmployee: null,
      start: this.toYMD(first),
      end: this.toYMD(last),
      rows: [],
      loading: false,
      error: null,
      shift_distribution:[],
      company_options:[],
      custom_list: [],
      summaryStats: [],
      errors: [],
      sortOrders: sortOrders,
      columns: columns,

        temp_length: 30,
        people: 0,
        length: 30,
        length_options: [
            { value: 30, text: "30" },
            { value: 60, text: "60" },
            { value: 180, text: "180" },
            { value: 365, text: "365" },
        ],
        pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
        blankmsg : 'Fetching data..',
        showoverlay : false,

    }
  },
  methods:{
    moment,
    showModal(){
      this.errors = [];
      this.$bvModal.show('bv-modal-manual-shift-assignment');
    },
    closeModal(errors = null){
      this.loadData();
      if(errors == null){
        this.$bvToast.toast('Shift Assigned Successfully', {
          variant: 'success',
          title: 'Success',
          solid: true,
        });
      } else {
        this.errors = errors;
      }
      this.$bvModal.hide('bv-modal-manual-shift-assignment');
    },
    toYMD(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    loadData() {
      if (!this.start || !this.end) return;
      this.loading = true;
      this.error = null;

      axios.get(this.$api_url + '/leave-attendance/assignments/employee', {
        params: {
          start: this.start,
          end: this.end,
        },
      }).then(response => {
        const data = response.data;

        this.rows = data.report;
        this.summaryStats = data.stat;

        const shiftByDay = new Map();
        for (const row of this.rows) {
          // Skip rows with no real shift (holiday / leave / day off placeholders)
          if (!row.shift || !row.shift.id) continue;

          // Key by day ONLY — a single day should count once, even if two
          // records exist for it (e.g. roster shift + manual override)
          shiftByDay.set(row.day, {
            id: row.shift.id,
            name: row.shift.name,
            color: row.shift.color,
          });
        }

        const counts = {};
        for (const { id, name, color } of shiftByDay.values()) {
          if (!counts[id]) {
            counts[id] = { id, name, color, count: 0 };
          }
          counts[id].count++;
        }

        this.shift_distribution = Object.values(counts);
        this.loading = false;
      }).catch(e => {
        this.serverError(e);
        this.loading = false;
      });
    },
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster
        }

      }.bind(this));

    },
  },
  mounted() {
    this.loadData();
    this.getCompanyLeaveSettings();
  },
    computed:
        {
        filteredData()
        {
            let filtered_list = this.rows;
            if (this.search)
            {
                filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                if(filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey)
            {
                filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                        a = String(a[sortKey]).toLowerCase();
                        b = String(b[sortKey]).toLowerCase();
                        if (this.columns[index].type && this.columns[index].type === 'date')
                        {
                            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                        }
                        else if (this.columns[index].type && this.columns[index].type === 'number')
                        {
                            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                        }
                        else
                        {
                            return (a === b ? 0 : a > b ? 1 : -1) * order;
                        }
                    }
                );
            }

            return filtered_list;
        },
        paginatedData()
        {
            this.people = this.filteredData.length;
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
